module.exports = __webpack_public_path__ + "static/media/drop_aro_outline.a8374e0e.svg";